import {Button, Result} from "antd";
import React from "react";
import {ExclamationCircleOutlined} from "@ant-design/icons";
import {payNow} from "../PayNow";
import LayoutHeader from "../../../layoutv2/header";

const ErrorPaymentStatus = () => {
    const height = window.innerHeight;
    const title = () => {
        return (
            <span
                style={{
                    color: "#101828",
                    fontFamily: "Open Sans"
                }}
                className={"font-semibold text-3xl"}
            >
                Thời hạn sử dụng Dogoo Office đã hết
            </span>
        )
    }

    const subTitle = () => {
        return (
            <>
                <div
                    style={{
                        color: "#475467"
                    }}
                    className={"text-lg"}
                >
                    Để công việc không bị gián đoạn.
                </div>
                <div
                    style={{
                        color: "#475467"
                    }}
                    className={"text-lg"}
                >
                    Quý khách nên <span className={"font-bold"}> gia hạn </span> thêm thời gian sử dụng
                </div>
            </>
        )
    }
    return (
        <div style={{ height : height - 64 }}>
            <LayoutHeader/>
            <div className={"flex h-full justify-center items-center"}>
                <Result
                    icon={
                        <div className={"w-16 h-16 flex justify-center items-center "}
                             style={{backgroundColor: "#FFF6ED", borderRadius: 40}} >
                            <div className={"w-12 h-12 flex justify-center items-center "}
                                 style={{backgroundColor: "#FFE1C4", borderRadius: 28}}>
                                <div style={{color: "#EF6820"}}>
                                    <ExclamationCircleOutlined style={{fontSize: 23}} color={"#EF6820"}/>
                                </div>
                            </div>
                        </div>
                    }
                    status="warning"
                    title={title()}
                    subTitle={subTitle()}
                    extra={
                        <Button type="primary" key="payment"
                                style={{ height : 40, width: 169 , backgroundColor: "#EF6820" }}
                                onClick={() => payNow()}>
                            Gia hạn ngay
                        </Button>
                    }
                    className={"do-goo-customer-result-icon"}
                />
            </div>
        </div>
    );
};

export default ErrorPaymentStatus;
